import type { LanguageOption } from "./types";

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: "en", label: "EN" },
  { value: "de", label: "DE" },
];
